import { useState, useEffect, useRef, useCallback } from 'react';
import React, { useMemo } from 'react';
import { ButtonGroup, ToggleButton, Row, Col, Button } from 'react-bootstrap'
import { EcgWebSocketReceiver } from './EcgWebSocketReceiver'
//import { EcgHighcharts } from './EcgHighcharts'
import { EcgHighchartsAsync as EcgHighchartsAsyncRaw } from './EcgHighchartsAsync';
import { EcgHighchartsAsyncWithNewNav as EcgHighchartsAsyncWithNewNavRaw } from './EcgHighchartsAsyncWithNewNav';
import { BreathingHighchartsAsync as BreathingHighchartsAsyncRaw } from './BreathingHighchartsAsync';
import { TemperatureHighchartsAsync as TemperatureHighchartsAsyncRaw } from './TemperatureHighchartsAsync';


import { ProcessedCalculatedData } from '../Processed/ProcessedCalculatedData'
import { OnlineDataPanel } from './OnlineDataPanel'

import DropdownDisplayTime from './DropdownDisplayTime'

import { useTranslation } from 'react-i18next';

import styles from './BaseMultipleChartsView.module.scss';
import CommentsSidebar from './CommentsSidebar';
import { CycleClickSelector } from './CycleSelection';

import * as CommonIcons from '../../CommonIcons';
import { NAVIGATION_CONFIG } from '../../../config/navigationConfig';
// Body position now displayed inside ECG navigation controls


const EcgHighchartsAsync = React.memo(EcgHighchartsAsyncRaw);
const EcgHighchartsAsyncWithNewNav = React.memo(EcgHighchartsAsyncWithNewNavRaw);
const BreathingHighchartsAsync = React.memo(BreathingHighchartsAsyncRaw);
const TemperatureHighchartsAsync = React.memo(TemperatureHighchartsAsyncRaw);

//import { CommonHighcharts } from './CommonHighcharts'

export function BaseMultipleChartsView({ dataList, realtimeDataUrl, chartDataTypes, baseRecordUrl, processedDataReady, timeViewMode, recordStartDate, timeTypeChangeCallback, processedDataReceived, allowEditMarkers, onCycleSelected, isAnalyzingCycle = false }) {
  const { t } = useTranslation();

  // Feature flag for new ECG navigation
  const [useNewEcgNavigation, setUseNewEcgNavigation] = useState(
    //localStorage.getItem('useNewEcgNavigation') === 'true'
    true
  );

  // Cycle selection state
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [selectedCycleData, setSelectedCycleData] = useState(null);
  const [rPeakData, setRPeakData] = useState([]);

  const chartEcgRef = useRef(null);
  const chartBreathingRef = useRef(null);
  const chartTemperatureRef = useRef(null);

  const chartRefArray = useRef([
    {
      dataTypeId: 1, ref: chartEcgRef, yAxis: [
        { title: { text: t('recordView.multiChart.seriesName.ecg') }, labels: { format: '{value} mV' }, opposite: false }]
    },
    {
      dataTypeId: 2,
      ref: chartBreathingRef,
      yAxis: [{
        title: { text: t('recordView.multiChart.seriesName.breathing') },
        labels: { format: '{value} Ohm' },
        opposite: false
      }],
      //copy:
      //{
      //  chart: chartEcgRef,
      //  yAxisId: 'y-breath',
      //  seriesName: t('recordView.multiChart.seriesName.breathing'),
      //  seriesId: 'series-breath',
      //  yAxis: [{ title: { text: t('recordView.multiChart.seriesName.breathing') }, labels: { format: '{value} Ohm' }, opposite: true, id: 'y-breath' }]
      //}
    },
    { dataTypeId: 3, ref: chartTemperatureRef, yAxis: [{ title: { text: t('recordView.multiChart.seriesName.temp') }, labels: { format: '{value} \u00B0C' }, opposite: false }] },
    //{ dataTypeId: 4, ref: chartAccelX, yAxis: [{ title: { text: t('recordView.multiChart.seriesName.accelX') }, labels: { format: '{value}' }, opposite: false }] },
    //{ dataTypeId: 5, ref: chartAccelY, yAxis: [{ title: { text: t('recordView.multiChart.seriesName.accelY') }, labels: { format: '{value}' }, opposite: false }] },
    //{ dataTypeId: 6, ref: chartAccelZ, yAxis: [{ title: { text: t('recordView.multiChart.seriesName.accelZ') }, labels: { format: '{value}' }, opposite: false }] },
  ]);  

  const [realtimeViewMode, setRealtimeViewMode] = useState(0); //0 - update navigator only, 1 - refresh (not used), 2 - live (scroll to latest)

  const [scrollToLatest, setScrollToLatest] = useState(false); 

  const realtimeModeRef = useRef(0);
  //const isChartInitialized = useRef(false);
  const chartDataArray = useRef([]);

  const ONLINE_STATE_NO_ONLINE = 0;
  const ONLINE_STATE_WAITING = 10;
  const ONLINE_STATE_RECEIVING = 20;
  const ONLINE_STATE_FINISHED = 30;

  // Initialize online state based on realtimeDataUrl presence
  // If realtimeDataUrl exists, this is an online/pending record from the start
  const [onlineTransmissionState, setOnlineTransmissionState] = useState(() => {
    return realtimeDataUrl ? ONLINE_STATE_WAITING : ONLINE_STATE_NO_ONLINE;
  }); 
  const [processedData, setProcessedData] = useState(null);
  const onFirstTransferOnly = useRef(true);
  const [showComments, setShowComments] = useState(false);
  const [sidebarPosition, setSidebarPosition] = useState({ top: 0, left: 0 });
  const commentDivRef = useRef(null);
  const [ecgSelectedRange, setEcgSelectedRange] = useState(null);

  useEffect(() => {    

    if (chartDataTypes.length > 0) {
      //init charts
      //console.log('init charts');
      chartDataTypes.map((item) => initChart(item));
    }

    if (dataList.items && dataList.items.length > 0) {     
      //console.log('init data');
      //if (!isChartInitialized.current) {
        chartDataTypes.map((item) => addInitialData(item));
      //  isChartInitialized.current = true;
      //}
    }

  }, [dataList, chartDataTypes]);

  useEffect(() => {
    if (!showComments) return;
    const updatePosition = () => {
      if (commentDivRef.current) {
        const rect = commentDivRef.current.getBoundingClientRect();
        setSidebarPosition({
          top: rect.bottom + window.scrollY +4,
          left: rect.left + window.scrollX,
          width: rect.width
        });
      }
    };
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);
    updatePosition();
    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [showComments]);

  // Cleanup effect to ensure charts are destroyed when time mode changes
  useEffect(() => {
    return () => {
      //console.log('clog: Destroying all chart instances due to timeViewMode change');
      // Note: The individual chart components will handle their own cleanup
      // when they unmount due to the key prop change
    };
  }, [timeViewMode]);

  const getChartDataByType = (type) => {    
    let filtered = chartRefArray.current.find(x => x.dataTypeId === type);
    if (filtered)
      return filtered;      
   
    return null;
  };

  const initChart = (chartType) => {
    //console.log('chart for ', chartType, ' initialized');
    let chartRef = getChartDataByType(chartType);
    if (chartRef) {
      chartRef.ref.current.setupYAxis(chartRef.yAxis);         
      if (chartRef.copy) {
        let copyChart = chartRef.copy.chart.current;
        if (chartRef.copy.yAxis)
          copyChart.setupYAxis(chartRef.copy.yAxis);
      }

      addDataToChart(chartType, { data: [] });
    }
  };

  const addDataToChart = (chartType, dataObject) => {
    let chartRef = getChartDataByType(chartType);
    if (chartRef) {
      //console.log('dataObject ', dataObject);

      if (dataObject.longRecord) {
        // Pass comment markers with long record data
        const longRecordWithComments = {
          ...dataObject.longRecord,
          commentMarkers: dataObject.commentMarkers
        };
        const asyncUrl = `${baseRecordUrl}/partial?type=${chartType}&timeType=${timeViewMode}`;

        // For ECG only, preload first row data immediately (skip online records)
        let initialLoadRange = null;
        if (chartType === 1 && !realtimeDataUrl) {
          const rowDurationMs = NAVIGATION_CONFIG.MINUTES_PER_ROW * 60 * 1000;
          if (timeViewMode === 1 && recordStartDate) {
            const recordStartMs = new Date(recordStartDate).getTime();
            initialLoadRange = { startMs: recordStartMs, endMs: recordStartMs + rowDurationMs, centerMs: recordStartMs };
          } else {
            initialLoadRange = { startMs: 0, endMs: rowDurationMs, centerMs: 0 };
          }
        }

        chartRef.ref.current.setInitialDataForLongSeries(longRecordWithComments, asyncUrl, null, initialLoadRange);


      } else {
        let data = dataObject.data;

        chartRef.ref.current.setInitialData(data);

        if (chartRef.copy) {
          let copyChart = chartRef.copy.chart.current;
          copyChart.setInitialData(data, { seriesId: chartRef.copy.seriesId, name: chartRef.copy.seriesName, yAxisId: chartRef.copy.yAxisId, color: 'green' });
        }

        if (realtimeDataUrl)
          setTimeout(() => chartRef.ref.current.scrollToEnd(), 100);
      }
    }
  };

  const addAnnotationsToEcgChart = (record) => {
    let newAnnotations = { labels: [] };
    newAnnotations.labels = record.dataObject.map((item, index) =>
      ({
        point: {
          x: item.x,
          y: item.y,
          xAxis: 0,
          yAxis: 0
        },
        text: `R #${index}<br>RR:${item.rr}<br>HR:${item.hr}`
      }));

    chartEcgRef.current.addAnnotation(newAnnotations);

    // Store R-peak data for cycle selection
    const rPeaks = record.dataObject.map((item, index) => ({
      number: index,
      timeMs: item.x,
      y: item.y,
      rrMs: item.rr,
      hr: item.hr
    }));
    setRPeakData(rPeaks);
  }

  const addInitialData = function (chartType, index) {
    //if (!isChartInitialized.current)
    if (dataList.items.length > 0) {
      let dataByType = dataList.items.find(x => x.dataType == chartType);

      let dataArray = { dataType: chartType, data: [] };

      if (dataByType && (dataByType.data || dataByType.longRecord)) {
        if (dataByType.data)
          dataByType.data.map(x => dataArray.data.push([x[0], x[1]]));
        dataArray.longRecord = dataByType.longRecord;
        dataArray.commentMarkers = dataByType.commentMarkers; // Include comment markers


        if (chartDataArray.current.find(x => x.dataType == chartType)) {
          chartDataArray.current = chartDataArray.current.filter(x => x.dataType != chartType);
        }
        chartDataArray.current.push(dataArray);
      }
    }

    //add existing data to the chart
    let filteredDataArray = chartDataArray.current.find(x => x.dataType == chartType);
    if (filteredDataArray) {
      addDataToChart(chartType, filteredDataArray);

      //if ECG and RR interval list exists, then add annotations to the chart
      if (chartType == 1) {
        let annotations = dataList.items.find(x => x.dataType == 101);
        if (annotations) addAnnotationsToEcgChart(annotations);
      }
    }
  };

  const newDataReceived = (data) => {    
    
    //console.log(data);

    // Handle processed-only updates
    if (data.processedOnly) {
      setProcessedData(data.processed);
      if (processedDataReceived) {
        processedDataReceived(data.processed);
      }
      return;
    }

    //initChart();
    //console.log('mode: ', realtimeModeRef.current);
    ////console.log('ecgChartDataArray: ', ecgChartDataArray.current);

    //console.log('data: ', data);

    if (onFirstTransferOnly.current) {
      setTimeout(() => setLiveViewMode(3), 500);
      onFirstTransferOnly.current = false;
    }

    if (onlineTransmissionState !== data.onlineState) {      
      setOnlineTransmissionState(data.onlineState);
    }

    data.items.forEach((item, index) => {
      let chartRef = getChartDataByType(item.dataType);
      if (chartRef && chartRef.ref && chartRef.ref.current) {
        //console.log('newDataReceived ', chartRef, item);
        chartRef.ref.current.addNewDataToChartLongSeries(item);

        //chartRef.ref.current.addNewDataToChart(item.data);

        //if (chartRef.copy) {
        //  let copyChart = chartRef.copy.chart.current;
        //  //setup axis here for a duplicate??
        //  copyChart.addNewDataToChart(item.data, chartRef.copy.seriesId);
        //}
      }
    });

    setProcessedData(data.processed);
    if (processedDataReceived)
      processedDataReceived(data.processed);
  };

  const finalize = () => {
    setOnlineTransmissionState(ONLINE_STATE_FINISHED);
    console.log('Finished');
  };

  const setMode = (mode) => {
    setRealtimeViewMode(mode);
    realtimeModeRef.current = mode;
    chartRefArray.current.map(x => {
      if (x.ref && x.ref.current)
        x.ref.current.setDataViewMode(mode);
    });
  }

  const setContinuousMode = () => {
    setMode(0);
  };

  const setRefreshMode = () => {
    setMode(1);   
  }; 

  const setLiveViewMode = () => {
    setMode(2);
    //if (!scrollToLatest) {
    //  setMode(2);
    //  setScrollToLatest(true);
    //} else {
    //  setMode(0);
    //  setScrollToLatest(false);
    //}
  };

  const setChartDisplayTime = (mode) => {            
    // Clear all chart data before switching modes to prevent mixed time formats
    chartRefArray.current.forEach((x, index) => {
      if (x.ref && x.ref.current && x.ref.current.clearAllChartData) {
        //console.log(`clog: Clearing chart data for chart ${index} (dataType: ${x.dataTypeId})`);
        x.ref.current.clearAllChartData();
      }
    });
    
    if (timeTypeChangeCallback) {
      //console.log('clog: Calling timeTypeChangeCallback with mode:', mode);
      timeTypeChangeCallback(mode);
    }
  };

  const onCommentClickCallback = (commentTimeMs) => {    
    chartEcgRef.current.moveChartToPosition(commentTimeMs);
  };

  const ecgExtremesChangedCallback = useCallback((min, max) => {
    setEcgSelectedRange(prev => {
      if (!prev || prev.min !== min || prev.max !== max) {
        return { min, max };
      }
      return prev;
    });
  }, []);

  const handleCommentUpdate = useCallback((comments) => {
    // Update comments on the ECG chart (navigation only)
    if (chartEcgRef.current && chartEcgRef.current.updateComments) {
      chartEcgRef.current.updateComments(comments);
    }
  }, []);

  // Handle cycle selection for diagnostic analysis
  const handleCycleSelect = useCallback((cycleNumber, cycleData) => {
    console.log('handleCycleSelect called:', cycleNumber, cycleData);
    setSelectedCycle(cycleNumber);
    setSelectedCycleData(cycleData);
    // Notify parent component if callback provided
    if (onCycleSelected) {
      onCycleSelected(cycleNumber, cycleData);
    }
  }, [onCycleSelected]);

  // Handle analyze button click - triggers diagnostic calculation
  const handleAnalyzeCycle = useCallback((cycleNumber, cycleData) => {
    console.log('Analyze cycle requested:', cycleNumber, cycleData);
    // Navigate chart to the selected cycle
    if (chartEcgRef.current && cycleData?.timeMs) {
      chartEcgRef.current.moveChartToPosition(cycleData.timeMs);
    }
    // Notify parent to trigger analysis
    if (onCycleSelected) {
      onCycleSelected(cycleNumber, cycleData, true); // third param indicates analyze request
    }
    // Close the selection panel after triggering analysis
    setSelectedCycle(null);
    setSelectedCycleData(null);
  }, [onCycleSelected]);

  return (
    <>
      {realtimeDataUrl && (
        <OnlineDataPanel
          processedData={processedData}
          onlineTransmissionState={onlineTransmissionState}
          onScrollToEndCallback={() => {
            console.log('=== BaseMultipleChartsView: onScrollToEndCallback CLICKED ===');
            setLiveViewMode();
            if (chartEcgRef.current) {
              if (chartEcgRef.current.setOnlinePreviewMode) {
                console.log('BaseMultipleChartsView: Calling setOnlinePreviewMode(true)');
                chartEcgRef.current.setOnlinePreviewMode(true);
              }
              if (chartEcgRef.current.scrollToEnd) {
                console.log('BaseMultipleChartsView: Calling scrollToEnd()');
                chartEcgRef.current.scrollToEnd();
              } else {
                console.warn('BaseMultipleChartsView: scrollToEnd method not found on chart ref!');
              }
            } else {
              console.warn('BaseMultipleChartsView: chartEcgRef.current is null!');
            }
          }}
        />
      )}

      <Row>
        <div className={styles.flexRowBetween}>
          <div className={styles.selectedBgGroup} ref={commentDivRef} >
            <div className={styles.selectedBg}>
              <Button               
                className={showComments ? `${styles.commentButton} ${styles.commentButtonActive}` : styles.commentButton} 
                onClick={() => setShowComments((prev) => !prev)}
              >
                <CommonIcons.ClientMessageButton /> {t('recordView.comments.button')}
              </Button>
              {showComments && (
                <CommentsSidebar
                  show={showComments}
                  onClose={() => setShowComments(false)}
                  baseUrl={`${baseRecordUrl}/comments`}
                  timeViewMode={timeViewMode}
                  onCommentClickCallback={onCommentClickCallback}
                  position={sidebarPosition}
                />
              )}
            </div>
            <div className={styles.selectedBg}>
              <DropdownDisplayTime currentMode={timeViewMode} onSelectionChangedCallback={(mode) => setChartDisplayTime(mode)} />
            </div>
          </div>
        </div>
      </Row>

      <Row>
        <Col>
          <span>{t('recordView.multiChart.chartHeader.ecg')}</span>
        </Col>
      </Row>
      <Row>
        <Col>
          {/*<EcgHighcharts ref={chartEcgRef} />*/}
          {useNewEcgNavigation ? (
            <EcgHighchartsAsyncWithNewNav
              key={`ecg-${timeViewMode}-new`}
              ref={chartEcgRef}
              extremesChangedCallback={ecgExtremesChangedCallback}
              baseRecordUrl={baseRecordUrl}
              useActualTime={timeViewMode === 1}
              onlineTransmissionState={onlineTransmissionState}
              allowEditMarkers={allowEditMarkers}
              onRPeakClick={handleCycleSelect}
            >
              {/* Cycle selection overlay - only show when cycle selection is enabled (onCycleSelected provided) */}
              {onCycleSelected && (rPeakData.length > 0 || selectedCycleData !== null) && (
                <CycleClickSelector
                  chartRef={chartEcgRef}
                  rPeaks={rPeakData}
                  selectedCycle={selectedCycle}
                  selectedCycleData={selectedCycleData}
                  onCycleSelect={handleCycleSelect}
                  onAnalyzeClick={handleAnalyzeCycle}
                  showHint={!selectedCycleData && rPeakData.length > 0}
                  isAnalyzing={isAnalyzingCycle}
                />
              )}
            </EcgHighchartsAsyncWithNewNav>
          ) : (
            <div style={{ position: 'relative' }}>
              <EcgHighchartsAsync
                key={`ecg-${timeViewMode}`}
                ref={chartEcgRef}
                extremesChangedCallback={ecgExtremesChangedCallback}
              />
              {onCycleSelected && (rPeakData.length > 0 || selectedCycleData !== null) && (
                <CycleClickSelector
                  chartRef={chartEcgRef}
                  rPeaks={rPeakData}
                  selectedCycle={selectedCycle}
                  selectedCycleData={selectedCycleData}
                  onCycleSelect={handleCycleSelect}
                  onAnalyzeClick={handleAnalyzeCycle}
                  showHint={!selectedCycleData && rPeakData.length > 0}
                  isAnalyzing={isAnalyzingCycle}
                />
              )}
            </div>
          )}
        </Col>
      </Row>
      

      {chartDataTypes.length > 1 && (
        <>
          <Row>
            <Col>
              <span>{t('recordView.multiChart.chartHeader.breathing')}</span>
              {/*<BreathingHighcharts ref={chartBreathingRef} seriesName={t('recordView.multiChart.seriesName.breathing')} />*/}
              <BreathingHighchartsAsync 
                key={`breathing-${timeViewMode}`}
                ref={chartBreathingRef} 
                seriesName={t('recordView.multiChart.seriesName.breathing')} 
              />
            </Col>
            <Col>
              <span>{t('recordView.multiChart.chartHeader.temp')}</span>
              {/*<TemperatureHighcharts ref={chartTemperatureRef} seriesName={t('recordView.multiChart.seriesName.temp')} />*/}
              <TemperatureHighchartsAsync 
                key={`temperature-${timeViewMode}`}
                ref={chartTemperatureRef} 
                seriesName={t('recordView.multiChart.seriesName.temp')} 
              />
            </Col>
          </Row>
        </>
      )}
      

      {/* <h3 style={{ display: 'none' }}>Hovering over {hoverData}</h3> */}
      {realtimeDataUrl && <EcgWebSocketReceiver realtimeDataUrl={realtimeDataUrl} receiveNewDataCallback={newDataReceived} finalizeCallback={finalize} timeViewMode={timeViewMode} onCommentUpdate={handleCommentUpdate} />}
    </>
  )


}
